export function getFullName(name) {
	let fullName = "";
	if (!!name) {
		const title = name.title && name.title.description && !name.title.isCompany ? name.title.description + " " : "";
		let firstName = "";
		if (!name.title || (name.title && !name.title.isCompany)) {
			firstName = !!name.firstName ? name.firstName + " " : "";
		}

		const lastName = !!name.lastName ? name.lastName : "";
		fullName = title + firstName + lastName;
	}
	return fullName;
}

export function getCodeFromItem(item) {
	return (item && item.code) ? item.code : (item || "");
}

export function getDescription(code, list, descriptionName = "description") {
	let description = "";
	if (code && list) {
		list.every(item => {
			if (item.code === code) {
				description = item[descriptionName];
				return false;
			}
			return true;
		});
	}
	return description;
}

export function getCode(description, list, fieldName = "code", descriptionName = "description") {
	let code = "";
	if (description && list) {
		list.every(item => {
			if (item[descriptionName] === description) {
				code = item[fieldName];
				return false;
			}
			return true;
		});
	}
	return code;
}

export function getListItemByCode(code, list, fieldName = "code") {
	let result = "";
	if (code && list) {
		list.every(item => {
			if (item[fieldName] === code) {
				result = item;
				return false;
			}
			return true;
		});
	}
	return result;
}

export function getValue(source) {
	let value = null;
	if (source && source.target) { //check if source is an event
		if(source.target.type === "checkbox"){ // check if it is a checkbox
			value = source.target.checked;
		} else if (source.target.selectedOptions) { // check if it is a dropdown
			value = (source.target.selectedIndex && source.target.selectedOptions[0].value) || null;
		} else {
			value = source.target.value;
		}
	} else {
		value = source;
	}
	return value;
}

export function downloadPdf(pdf, name) {
	const downloadLink = document.createElement('a');
	downloadLink.target = '_blank';
	downloadLink.download = name + '.pdf';
	const downloadUrl = "data:application/force-download;charset=utf-16le;base64," + pdf;
	downloadLink.href = downloadUrl;
	document.body.appendChild(downloadLink);
	downloadLink.click();
	document.body.removeChild(downloadLink);
}

export function groupClass(field) {
	let isValid = true;
	if (Array.isArray(field)) {
		field.forEach((fieldName) => {
			isValid = isValid && this.props.isValid(fieldName);
		});
	} else {
		isValid = this.props.isValid(field);
	}
	return isValid ? 'form-group' : 'form-group has-error';
}

export function jump(event, maxLength){
	const input = event.target.value;
	event.target.value = input.toUpperCase();
	inputUppercase(event);
	if (!!input && (input.length === maxLength)) {
		!!event.target.nextSibling && event.target.nextSibling.focus();
	}
}

export function inputUppercase(event) {
	event.target.value = event.target.value.toUpperCase();
};



// WEBPACK FOOTER //
// ./src/opencell/pages/utils/FormUtils.js